import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ServiceMenusTabs from './ServiceMenusTabs'
import { indexPageMaxContentWidth } from 'config/theme'

const HomeServiceMenus = ({
  catalogsServiceMenus,
  isSmall,
  isMobile,
  handleTabChange,
  handleSubMenusLinkClick,
}) => (
  <Box
    maxWidth={indexPageMaxContentWidth}
    margin="0 auto"
    mb={4}
    px={{ xs: 4, md: 8, xl: 12 }}
  >
    {catalogsServiceMenus?.[0]?.homeServiceMenuTitle && (
      <Typography
        color="text.minus1"
        variant={isSmall ? 'titleLarge' : 'headlineMedium'}
      >
        {catalogsServiceMenus[0]?.homeServiceMenuTitle}
      </Typography>
    )}
    {catalogsServiceMenus && catalogsServiceMenus.length > 0 && (
      <ServiceMenusTabs
        catalogsServiceMenus={catalogsServiceMenus}
        onTabChange={handleTabChange}
        onSubMenusLinkClick={handleSubMenusLinkClick}
        isMobile={isMobile}
      />
    )}
  </Box>
)

export default HomeServiceMenus
